// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const fixSafariIos = "Overlay__fixSafariIos__6HRD7";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const isHeightSet = "Overlay__isHeightSet__KMWdg";
export const medium = "500";
export const overlay = "Overlay__overlay__mxgNQ";
export const overlayMobileHeight = "var(--overlay-mobile-height)";
export const overlayShrunkSidebar = "Overlay__overlayShrunkSidebar__gH9Mj";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const textCenter = "Overlay__textCenter__KGhNF";